export interface Session {
    appointmentModification: boolean;
    customerId?: number;
    appointmentRef?: string;
}

export const SessionName = 'CREER_RDV_ROBE';
